/* eslint-disable no-empty */
// src/embed/widget-upsell-order-form.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import TaxPros from "../components/Lists/TaxPros/TaxPros"
import "./widget-styles.scss";

const toCamel = (s) => s.replace(/[-_](\w)/g, (_, c) => c.toUpperCase());
const parse = (v) =>
  v == null
    ? undefined
    : v === ""
    ? true
    : v === "true"
    ? true
    : v === "false"
    ? false
    : v;

// Hosts that actually serve /.netlify/functions/api-proxy. Optimizers like
// NitroPack rehost the widget JS on the WordPress origin while keeping the
// original tools host inside the rewritten path, so match a known host
// anywhere in the src rather than trusting the URL's origin.
const TOOLS_HOSTS = ["tools.unclekam.com", "tools-unclekam.netlify.app"];

function toolsOriginFromSrc(src) {
  if (!src) return "";
  try {
    const u = new URL(src, location.href);
    if (TOOLS_HOSTS.includes(u.hostname)) return u.origin;
  } catch {}
  for (const host of TOOLS_HOSTS) {
    if (src.includes(`/${host}/`) || src.includes(`//${host}/`)) {
      return `https://${host}`;
    }
  }
  return "";
}

function detectToolsOrigin() {
  const fromCur = toolsOriginFromSrc(document.currentScript && document.currentScript.src);
  if (fromCur) return fromCur;
  const scripts = Array.from(document.getElementsByTagName("script"));
  for (let i = scripts.length - 1; i >= 0; i--) {
    const fromScan = toolsOriginFromSrc(scripts[i].src || "");
    if (fromScan) return fromScan;
  }
  const isQA = new URLSearchParams(location.search).has("qa_mode");
  return isQA ? "https://tools-unclekam.netlify.app" : "https://tools.unclekam.com";
}

function register(tagName, Comp, { attrToProp = {} } = {}) {
  if (customElements.get(tagName)) return;

  class ReactElement extends HTMLElement {
    static get observedAttributes() {
      const keys = Object.keys(attrToProp);
      return keys.length
        ? keys
        : [ "redirectUrl", "qa_mode", ];
    }

    _propsFromAttrs() {
      const props = {};
      if (Object.keys(attrToProp).length) {
        for (const [attr, prop] of Object.entries(attrToProp)) {
          props[prop] = parse(this.getAttribute(attr));
        }
      } else {
        for (const attr of this.getAttributeNames()) {
          props[toCamel(attr)] = parse(this.getAttribute(attr));
        }
      }
      return props;
    }

    _render() {
      if (!this._root) return;
      const p = this._propsFromAttrs();
      const origin = detectToolsOrigin();
      const proxyUrl = `${origin}/.netlify/functions/api-proxy`;
      window.__UK_PROXY_URL__ = proxyUrl;
      this._root.render(React.createElement(Comp, { ...p, proxyUrl }));
    }

    connectedCallback() {
      const mount = document.createElement("div");
      this.appendChild(mount);
      this._root = createRoot(mount);
      this._render();
    }
    attributeChangedCallback() { this._render(); }
    disconnectedCallback() { this._root?.unmount(); this._root = null; }
  }

  customElements.define(tagName, ReactElement);
}

register("taxpro-list", TaxPros, {
  attrToProp: {
    qa_mode: "qa_mode",
    state: "state",
    roundRobin: "roundRobin",
  },
});
